import { Button, Input, Label, UncontrolledTooltip } from "reactstrap";

import Flex from "@components/ui-components/flex";
import classnames from "classnames";
import size from "lodash/size";
import useKPI from "./use-kpi";
import { useTranslation } from "react-i18next";

const SelectUnselectAll = (props) => {
    const { handleSelection } = props;
    const { t } = useTranslation();
    return (
        <Flex align="center">
            <Button
                className="btn-icon unselect-all-btn"
                id="unselect"
                outline
                data-cy="unselect-all"
                color={"danger"}
                onClick={() => handleSelection("clear")}>
                <i className="mdi mdi mdi-cancel" />
            </Button>
            <UncontrolledTooltip placement="top" target="unselect">
                {t("Clear All")}
            </UncontrolledTooltip>
            <Button
                className="btn-icon  select-all-btn"
                id="selectAll"
                outline
                data-cy="select-all"
                color="success"
                onClick={() => handleSelection("all")}>
                <i className="mdi mdi-checkbox-marked-outline cursor-pointer" />
            </Button>
            <UncontrolledTooltip placement="top" target="selectAll">
                {t("Select All")}
            </UncontrolledTooltip>
        </Flex>
    );
};
const KPI = (props) => {
    const {
        maxKPIAllowed,
        kpiOptions
    } = props;

    const { handleSelectActions, selectedKPI, handleKPI } =
    useKPI(props);

    const { t } = useTranslation();
    return (
        <>
            <Flex justify="between" align="center">
                <div>
                    <h5 className="m-0 fw-bolder">{t("KPI")}</h5>
                    {maxKPIAllowed ? (
                        <p className="text-muted">
                            {t(`Maximum ${maxKPIAllowed} allowed`)}
                        </p>
                    ) : null}
                </div>
                <Flex justify="between" align="center">
                    <SelectUnselectAll handleSelection={handleSelectActions}/>
                </Flex>
            </Flex>
            <div className="group-row">
                {kpiOptions.map((item, index) => {
                    const isItemDisabled = item.disabled;
                    const maxAllowed = maxKPIAllowed;
                    const isMaxKPIAllowed = maxAllowed ? !selectedKPI?.includes(item.value) &&
              size(selectedKPI) === Number(maxAllowed) : false;
                    const isDisabled = isItemDisabled || isMaxKPIAllowed;

                    return (
                        <div
                            className="position-relative"
                            key={index}
                            id={
                                selectedKPI?.includes(item.value) ? "" : `${item.value}-disabled-kpi`
                            }>
                            <Input
                                type="checkbox"
                                id={item.value}
                                disabled={isDisabled}
                                name={item.value}
                                onChange={({ target }) => {
                                    handleKPI(target.value);
                                }}
                                style={{ width: "15px", height: "15px" }}
                                className={"fw-bolder m-0 customCheckbox"}
                                checked={selectedKPI?.includes(item.value)}
                                value={item.value}/>
                            <Label
                                htmlFor={item.value}
                                // style={{ padding: "0.4rem 1rem" }}
                                className={classnames(
                                    "font-small-2 mb-0 checkbox-label w-100 filter-checkbox",
                                    {
                                        active    : selectedKPI?.includes(item.value),
                                        border    : !selectedKPI?.includes(item.value),
                                        disabled  : isDisabled,
                                        "bg-white": !isDisabled
                                    }
                                )}>
                                <div className="label">
                                    {t(item.label)}
                                </div>
                            </Label>
                        </div>
                    );
                })}
            </div>
        </>
    );
};
export default KPI;
